import { render, staticRenderFns } from "./history-table.vue?vue&type=template&id=239b3eb2&"
import script from "./history-table.vue?vue&type=script&lang=js&"
export * from "./history-table.vue?vue&type=script&lang=js&"
import style0 from "./history-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports